"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function filterInActiveSelections(choice, options, choices) {
    const option = options[choice.optionId];
    if (choice.isSelected && option.isDependent) {
        const parentChoice = choices[option.parentChoiceId];
        if (parentChoice.isSelected && !option.isActive && choice.isActive) {
            return filterInActiveSelections(parentChoice, options, choices);
        }
        return false;
    }
    return choice.isSelected && choice.isActive && !option.isActive;
}
exports.default = filterInActiveSelections;
//# sourceMappingURL=filterInActiveSelections.js.map